import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const badgeSectionFn = /* @__PURE__ */ createRecipe('badge-section', {}, [])

const badgeSectionVariantMap = {}

const badgeSectionVariantKeys = Object.keys(badgeSectionVariantMap)

export const badgeSection = /* @__PURE__ */ Object.assign(memo(badgeSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'badgeSection',
  __getCompoundVariantCss__: badgeSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: badgeSectionVariantKeys,
  variantMap: badgeSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, badgeSectionVariantKeys)
  },
  getVariantProps: badgeSectionFn.getVariantProps,
})